import Input from "../../Input"

const TempChannel = ({ index, values, serverData }) => {
    return (
        <div className="mx-14 h-full">
            <h6 className="flex justify-center">چنل موقت</h6>
            <div className="grid grid-cols-2 gap-5">
                <div className="font-sans">
                    <Input
                        type="number"
                        name={`tempChannel-listenId`}
                        options={serverData?.channelList}
                        label="ایدی چنلی که وقتی جوین داد چنل ساخته بشه: *"
                        placeholder="ChannelID"
                        autoComplete="off"
                        defaultValue={values?.listenId}
                        dir="ltr"
                    />
                </div>
                <div className="">
                    <Input
                        type="number"
                        label="ایدی چنلی که چنل های موقت زیرش ساخته بشه: *"
                        name={`tempChannel-parentId`}
                        options={serverData?.channelList}
                        class="border   text-sm rounded-lg font-sans block w-full p-2.5 bg-gray-700 border-gray-600 placeholder-gray-400 text-white "
                        placeholder="ChannelID"
                        defaultValue={values?.parentId}
                        autoComplete="off"
                        dir="ltr"
                    />
                </div>
            </div>
            <div className="mt-2 grid grid-cols-2 gap-5">
                <div>
                    <Input
                        type="number"
                        label="ایدی رنکی که به کلاینت داده میشه"
                        options={serverData?.cgList}
                        name={`tempChannel-cgId`}
                        placeholder="ChannelGroupId"
                        defaultValue={values?.cgId}
                        autoComplete="off"
                        dir="ltr"
                    />
                </div>
                <div>
                    <Input
                        type="number"
                        label="ایدی ایکون"
                        name={`tempChannel-iconId`}
                        options={serverData?.iconList}
                        placeholder="IconId"
                        defaultValue={values?.iconId}
                        autoComplete="off"
                        dir="ltr"
                    />
                </div>
            </div>
            <div className="grid grid-cols-2 gap-5">
                <div className="">
                    <Input
                        type="text"
                        label="فورمت اسم چنل *"
                        name={`tempChannel-nameFormat`}
                        placeholder="NameFormat"
                        defaultValue={values?.nameFormat}
                        autoComplete="off"
                        dir="ltr"
                    />
                </div>
                <div className="">
                    <Input
                        type="text"
                        label="فورمت پوک"
                        name={`tempChannel-pokeFormat`}
                        placeholder="PokeFormat"
                        defaultValue={values?.pokeFormat}
                        autoComplete="off"
                        dir="ltr"
                    />
                </div>
            </div>
            <div className="mt-5 p-2 text-gray-400 border-gray-700 border rounded-md font-sans">
                <span>متغیرها:</span>
                <div dir="ltr" className="grid grid-cols-2">
                    <div>
                        <span dir="rtl">متغیر های پوک:</span>
                        <div>%client: اسم کلاینت</div>
                        <div>%password: پسورد چنل</div>
                    </div>
                    <div>
                        <span dir="rtl">متغیر های اسم چنل:</span>
                        <div>%client: اسم کلاینت</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TempChannel
